import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Form, message } from 'antd';
import PageTitle from 'apps/home/components/PageTitle';
import notificationLogApiCall from 'apps/investcore/notification-logs';
import ApiCall from 'apps/investcore/apiCalls/notifications';
import { useNavigate } from 'react-router-dom';
import SendNotificationForm from './send-form';

const listUrl = '/admin/notification-logs';

const SendNotificationPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (values: {
      user_ids: string[];
      title: string;
      body: string;
      screen_name?: string;
      id?: string;
    }) => ApiCall.send.queryFn(values),
    onSuccess: (res: any) => {
      const successCount = res?.data?.success_count ?? 0;
      const errorCount = res?.data?.error_count ?? 0;
      if (errorCount > 0) {
        message.warning(`Sent: ${successCount} succeeded, ${errorCount} failed`);
      } else {
        message.success(`Sent to ${successCount} user(s)`);
      }
      queryClient.invalidateQueries({
        queryKey: [notificationLogApiCall.list.queryKey],
      });
      navigate(listUrl);
    },
    onError: (err: any) => {
      message.error(err?.message || 'Failed to send notification');
    },
  });

  return (
    <>
      <PageTitle title="Send Notification" backUrl={listUrl} />
      <SendNotificationForm
        form={form}
        submiting={isPending}
        onFinish={(values: any) => mutate(values)}
        name="send_notification_form"
      />
    </>
  );
};

export default SendNotificationPage;
